<div *ngIf="mdLoading" class="models cust-select gts-sel prob-catg">
    <mat-icon *ngIf="splitIcon" class="material-icon media-material-icon model-icon"></mat-icon>
    <mat-form-field class="custom-mat-sel prob-catg-sel" [ngClass]="{'media-mat-sel': splitIcon}">
        <mat-select #selectopt panelClass="mat-bottom-panel" (openedChange)="openedChange($event)" placeholder="{{placeholder}}" [formControl]="mdFormControl" [(ngModel)]="dbSelectedMd" multiple disableOptionCentering>
            <div class="select-container" *ngIf="mdLoadingSelect">
                <mat-optgroup >
                    <mat-form-field style="width:100%;">
                        <input #search autocomplete="off" class="model-search-input" placeholder="{{searchPlaceholder}}" matInput [formControl]="mdSearchTextboxControl">
                        <button  *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
                        <mat-icon >close</mat-icon>
                        </button>
                    </mat-form-field>
                </mat-optgroup>
                <mat-optgroup *ngIf="(mdFilteredOptions | async).length == 0">
                    <div>No results found!</div>
                </mat-optgroup>
                <div *ngIf="selectClose" class="ngdialog-close" (click)="selectopt.close()">Close</div>
                <mat-option title="{{option}}" (onSelectionChange)="selectionChange($event)" *ngFor="let option of mdFilteredOptions | async" [value]="option" [disabled]="disableSelection(option)">
                {{option}}
                </mat-option>
            </div>
        </mat-select>
    </mat-form-field>
</div>
<div *ngIf="mdLoadingSelect" style="max-height: 170px;overflow: auto;">
    <div *ngIf="mdFormControl.value != ''" class="selected-items ps" [perfectScrollbar]="sconfig">
        <div *ngFor="let item of modelItems; let t=index" class="tag-text model-tag-text">
            <span>{{item}}</span>
            <i class="material-icons tag-close" (click)="disableTagSelection(t)">close</i>
        </div>
    </div>
</div>